module.exports = __webpack_public_path__ + "img/ahorro-agua.4ead1882.svg";